import Image from "@/components/global/Image";
import CurrencyIcon from "@/components/icons/CurrencyIcon";
import { ModalContext } from "@/pages/_app";
import { useContext } from "react";

function truncateToTwoDecimalPlaces(number) {
  const formattedNumber = Number(number?.toFixed(2));
  return formattedNumber.toFixed(2);
}

const TabbyWidget = ({
  price,
  locale,
  installments = 4,
  setOpen,
  setSelected,
}) => {
  const Context = useContext(ModalContext);
  return (
    <>
      <div className="flex items-center p-3 my-2 border rounded-md">
        <Image
          src="/imgs/payments/tabby_installments.png"
          width={85}
          height={28}
          className="w-16 md:w-[85px] h-7 object-contain"
          alt=""
        />
        <p className="flex flex-col items-center mx-4 max-sm:text-sm">
          <span className="flex flex-wrap items-center gap-1">
            {locale === "en" ? (
              <span className="flex flex-wrap items-center gap-1">
                <span>or Split it into {installments} payments of </span>
                <span>
                  {truncateToTwoDecimalPlaces((price || 0) / installments) ||
                    ""}{" "}
                </span>
                <CurrencyIcon className="size-3.5" />
                <span>interest-free</span>
              </span>
            ) : (
              <span className="flex flex-wrap items-center gap-1">
                <span>
                  أو قسّمها على {installments} دفعات {"بقيمة "}
                </span>
                <span>
                  {truncateToTwoDecimalPlaces((price || 0) / installments) ||
                    ""}{" "}
                </span>
                <CurrencyIcon className="size-3.5" /> بدون أي فوائد أو رسوم.
              </span>
            )}
            <span
              onClick={() => {
                Context?.dispatch({
                  type: "tabbyModal",
                  payload: {
                    installments,
                    price: truncateToTwoDecimalPlaces(price || 0) / 4,
                  },
                });
                setOpen && setOpen(false);
                setSelected && setSelected("tabby");
              }}
              className="underline cursor-pointer mx-0.5 font-semibold"
            >
              {locale === "en" ? "Learn more" : "اعرف المزيد"}
            </span>
          </span>
        </p>
      </div>
    </>
  );
};

export default TabbyWidget;
